import { Component, EventEmitter, inject, ViewEncapsulation } from '@angular/core';
import { OverlayService } from '@services/overlay';
import { CloseOverlayKeyboardDirective } from '../../directives/close-overlay.directives';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lv-biometrics-error',
  styleUrls: ['biometrics-error.component.scss'],
  templateUrl: 'biometrics-error.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [CloseOverlayKeyboardDirective, TranslateModule]
})
export class BiometricsErrorComponent {
  private overlayService = inject(OverlayService);

  allowHardRestart = false;
  restart: EventEmitter<any>;
  reset: EventEmitter<any>;

  resetBiometrics() {
    this.reset.emit();
    this.overlayService.closeTopOverlay();
  }

  hardRestart() {
    this.restart.emit();
    this.overlayService.closeTopOverlay();
  }
}
